import {
  extendVariants,
  Card,
  CardProps,
  CardBody,
  useDisclosure,
  cn,
} from '@nextui-org/react';
import { TestIdMixin } from '../types';
import { forwardRef } from 'react';
import { IoMdClose } from 'react-icons/io';
import { Button } from './Button';

export interface BannerProps extends CardProps, TestIdMixin {
  color?: 'default' | 'primary' | 'success' | 'danger' | 'gray' | 'info';
  isCloseable?: boolean;
}

const Component = extendVariants(Card, {
  variants: {
    color: {
      default: {
        base: 'bg-sandstone-400',
        body: 'p-4 font-bold',
      },
      gray: {
        base: 'bg-natural-black/5',
        body: 'p-4 font-bold',
      },
      primary: {
        base: 'bg-primary',
        body: 'p-4 text-white font-bold',
      },
      success: {
        base: 'bg-success',
        body: 'p-4 text-white font-bold',
      },
      danger: {
        base: 'bg-blush-600',
        body: 'p-4 text-white font-bold',
      },
      info: {
        base: 'bg-robins-egg-blue-200',
        body: 'p-4 text-natural-black',
      },
    },
  },
  defaultVariants: {
    color: 'default',
    radius: 'sm',
    shadow: 'none',
  },
});

export const Banner = forwardRef<HTMLDivElement | null, BannerProps>(
  ({ children, isCloseable = false, ...props }, ref) => {
    const { isOpen, onClose } = useDisclosure({ defaultOpen: true });

    return isOpen ? (
      <Component ref={ref} {...props}>
        <CardBody className={cn(isCloseable && 'pr-8')}>{children}</CardBody>
        {isCloseable && (
          <Button
            className="absolute top-0.5 right-0.5"
            size="sm"
            radius="full"
            isIconOnly
            variant="light"
            onPress={onClose}
          >
            <IoMdClose className="text-natural-black-600 text-2xl" />
          </Button>
        )}
      </Component>
    ) : (
      <></>
    );
  }
);
